import React from 'react';
import { Box, Paper, Typography, Chip } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { formatDate } from '../../utils/dateUtils';

/**
 * Consistent note card used everywhere notes are displayed (order details,
 * order workflow notes dialog, offer/enquiry notes, etc.) so every note -
 * regardless of where it was created - looks the same:
 *   [icon] User Name  [New]                         DD/MM/YY
 *   (Created from Ad Orders) The note content itself goes here.
 */
const NoteCard = ({ note, color = 'primary', bgColor, borderColor }) => {
  if (!note) return null;

  const displayContent = note.sourceLabel
    ? `(${note.sourceLabel}) ${note.content}`
    : note.content;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        bgcolor: note.isNew ? 'success.lighter' : (bgColor || 'grey.50'),
        borderColor: note.isNew ? 'success.light' : (borderColor || 'divider')
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <PersonIcon fontSize="small" color={color} />
          <Typography variant="subtitle2" color="text.primary" fontWeight={600}>
            {note.createdBy || 'Unknown User'}
          </Typography>
          {note.isNew && (
            <Chip label="New" size="small" color="success" variant="outlined" />
          )}
          {note.isLocal && (
            <Chip label="Local" size="small" color="warning" variant="outlined" />
          )}
        </Box>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap', ml: 2 }}>
          {formatDate(note.createdAt)}
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
        {displayContent}
      </Typography>
    </Paper>
  );
};

export default NoteCard;
